import React from 'react';
import { View, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';

import { IconButton } from './icon-button';
import { Text } from './text';

import { useTheme } from '@/components/theme-provider';

export interface BannerAction {
	label: string;
	onPress: () => void;
	loading?: boolean;
}

export interface BannerProps {
	visible: boolean;
	children: React.ReactNode;
	actions?: React.ReactNode | BannerAction[];
	icon?: string;
	onDismiss?: () => void;
	style?: ViewStyle;
}

export const Banner: React.FC<BannerProps> = ({
	visible,
	children,
	actions,
	icon,
	onDismiss,
	style,
}) => {
	const theme = useTheme();

	if (!visible) return null;

	return (
		<View style={[styles.banner, { backgroundColor: theme.colors.surfaceVariant }, style]}>
			<View style={styles.content}>
				{icon && (
					<IconButton
						icon={icon}
						size={20}
						style={styles.icon}
					/>
				)}
				<View style={styles.textContainer}>
					<Text variant="bodyMedium">
						{children}
					</Text>
				</View>
				{actions && (
					<View style={styles.actions}>
						{Array.isArray(actions) ? actions.map((action, index) => (
							<TouchableOpacity
								key={index}
								onPress={action.onPress}
								disabled={action.loading}
								style={styles.actionButton}
							>
								<Text variant="labelLarge" style={{ color: theme.colors.primary }}>
									{action.loading ? 'Loading...' : action.label}
								</Text>
							</TouchableOpacity>
						)) : actions}
					</View>
				)}
				{onDismiss && (
					<IconButton
						icon="close"
						onPress={onDismiss}
						size={20}
						style={styles.dismiss}
					/>
				)}
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	banner: {
		padding: 16,
		marginVertical: 4,
	},
	content: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	icon: {
		marginRight: 12,
	},
	textContainer: {
		flex: 1,
	},
	actions: {
		flexDirection: 'row',
		marginLeft: 12,
	},
	actionButton: {
		padding: 8,
	},
	dismiss: {
		marginLeft: 8,
	},
});
